<template>
  <div class="property_wrap">
    <div class="pro_top">企业招聘设置</div>
    <div class="pro_con">
      <el-form ref="form" label-width="80px">
        <el-form-item label="组件标题:">
          <el-input v-model="property.label" maxlength="10" show-word-limit></el-input>
        </el-form-item>
        <el-table
                :data="list"
                style="width: 100%;margin-bottom:30px;">
          <el-table-column
                  prop="position"
                  label="招聘职位"
                  width="120">
          </el-table-column>
          <el-table-column
                  label="职位薪资"
                  prop="salary">
          </el-table-column>
          <el-table-column
                  prop="experience"
                  label="经验要求"
                  width="100">
          </el-table-column>
          <el-table-column
                  label="状态">
            <template slot-scope="scope">
              <el-switch
                      @change="switchChange($event,scope.$index)"
                      v-model="scope.row.is_show"
                      active-color="#2AA3F8"
                      inactive-color="#ddd">
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column
                  label="操作"
                  width="150">
            <template slot-scope="scope">
              <el-button @click="addRecruit('edit',scope.$index)" size="small">编辑</el-button>
              <el-button @click="dislogFn(scope.$index)" size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-button type="primary" @click="addRecruit('add')" size="small">添加招聘</el-button>
      </el-form>
    </div>
    <addRecruitCompany
            :visible.sync="dialogVisible"
            @userDetail="userDetail"
            v-if="dialogVisible"
            :recruitId="recruitId"
    ></addRecruitCompany>
  </div>
</template>
<script>
  import api from "@/api.js";
  import addRecruitCompany from "@/components/dialog/addRecruitCompany.vue";

  export default {
    components: {
      addRecruitCompany
    },
    props: ["property"],
    data() {
      return {
        dialogVisible: false,
        form: {},
        recruitId: '',
        list: []
      };
    },
    watch: {
      property: {
        immediate: true,
        handler(val) {
          this.form = val
        }
      }
    },
    created() {
      if (this.property.list.length === 0) {
        this.form.list.push({position: '', salary: '', city: '', claim: '', edu: ''});
      }
      this.InitFn(1);
    },
    mounted() {
      this.$emit('update:property', this.form)
    },
    methods: {
      InitFn(option) {
        this.axios
            .post(api.companyadmin_recruitment_index, {})
            .then(response => {
              if (response.data.code == 0) {
                for (let i in response.data.list) {
                  // "is_select":"是否选中(0否、1是)",
                  if (response.data.list[i].is_select === 1) {
                    response.data.list[i].is_show = true
                    // this.form.list.push(response.data.list[i])
                    // 编辑状态
                    if (option === 2 && this.recruitId === response.data.list[i].id) {
                      for (let j in this.form.list) {
                        if (this.form.list[j].id === this.recruitId) {
                          // this.form.list[j] = response.data.list[i]
                          let list = {}
                          list.position = response.data.list[i].position;
                          list.salary = response.data.list[i].salary;
                          list.city = response.data.list[i].work_city + response.data.list[i].work_district;
                          list.claim = response.data.list[i].salary;
                          list.edu = response.data.list[i].experience;
                          list.id = response.data.list[i].id;
                          this.$set(this.form.list, j, list)
                        }
                      }
                    }
                  } else {
                    response.data.list[i].is_show = false
                  }
                }
                this.list = response.data.list
              } else {
              }
            })
            .catch(response => {
            });
      },
      userDetail() {
        this.InitFn(2);
      },
      addRecruit(option, index) {
        let recruitId = ''
        if (option === 'edit') {
          recruitId = this.list[index].id
        }
        this.recruitId = recruitId;
        this.dialogVisible = true;
      },
      switchChange(even, index) {
        // list position 职位 salary 薪资 city 城市 claim 经验要求 edu 学历
        // is_select
        let list = {position: '', salary: '', city: '', claim: '', edu: '', id: ''}
        if (even) {
          for (let i in this.form.list) {
            if (!this.form.list[i].id) {
              this.form.list.splice(i, 1)
            }
          }
          list.position = this.list[index].position;
          list.salary = this.list[index].salary;
          list.city = this.list[index].work_city + this.list[index].work_district;
          list.claim = this.list[index].salary;
          list.edu = this.list[index].experience;
          list.id = this.list[index].id;
          this.form.list.push(list);
        } else {
          for (let i in this.form.list) {
            if (this.form.list[i].id === this.list[index].id) {
              this.form.list.splice(i, 1)
              if (this.form.list.length === 0) {
                this.form.list.push({position: '', salary: '', city: '', claim: '', edu: ''})
              }
            }
          }
          // this.chooseId.splice(this.chooseId.indexOf(this.list[index].id), 1)
        }
      },
      dislogFn(index) {
        this.$confirm('该招聘信息将立即被删除,删除后无法恢复, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          iconClass: 'iconfont iconbangzhu warning-color'
        }).then(() => {
          this.detelLineFn(index)
        }).catch(() => {
        });
      },
      detelLineFn(index) {
        this.axios
            .post(api.companyadmin_recruitment_delete, {rec_id: this.list[index].id})
            .then(response => {
              if (response.data.code == 0) {
                if (this.list[index].is_show) {
                  for (let i in this.form.list) {
                    if (this.form.list[i].id === this.list[index].id) {
                      this.form.list.splice(i, 1)
                    }
                  }
                  if (this.form.list.length === 0) {
                    this.form.list.push({position: '', salary: '', city: '', claim: '', edu: ''})
                  }
                }
                this.list.splice(index, 1);
                this.$message({
                  message: '删除成功',
                });
              }
            })
            .catch(response => {
            });
      }
    }
  };
</script>

